// Celular de WhatsApp do destinatário (lembrete do ciclo, spec 2026-10-09 do back).
// Mesma regra de db/faturamentoWaCalc.js (normalizarCelularBR): DDD da Anatel +
// 9 dígitos começando em 9; aceita máscara, +55, 55 e 0 na frente. O back valida de novo.
const DDDS_BR = new Set([
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69,
    71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
    91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

export function validarCelularBR(entrada) {
    let d = String(entrada == null ? '' : entrada).replace(/\D/g, '');
    if (!d) return { ok: false, erro: 'Informe o celular com DDD.' };
    if (d.length === 13 && d.startsWith('55')) d = d.slice(2);
    if (d.length === 12 && d.startsWith('0')) d = d.slice(1);
    if (d.length === 10) return { ok: false, erro: 'Número com 8 dígitos parece fixo; o WhatsApp precisa de celular (DDD + 9 dígitos).' };
    if (d.length !== 11) return { ok: false, erro: 'Celular deve ter DDD + 9 dígitos.' };
    if (!DDDS_BR.has(Number(d.slice(0, 2)))) return { ok: false, erro: `DDD ${d.slice(0, 2)} inválido.` };
    if (d[2] !== '9') return { ok: false, erro: 'Celular deve começar com 9 depois do DDD.' };
    return { ok: true, numero: `55${d}` };
}

// '5551999991234' -> '(51) 99999-1234'
export function formatarCelular(numero) {
    const d = String(numero || '').replace(/\D/g, '');
    const local = d.length === 13 && d.startsWith('55') ? d.slice(2) : d;
    if (local.length !== 11) return numero || '';
    return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
}
